import { ROUTERS } from '@/constant';
import { searchParamsKey, useCreateListSubmit } from '@/hooks';
import { memo, useCallback, useMemo } from 'react';

import Button from '../common/button';
import { DefineDocumentUploadButtonProps } from './define-document-upload.type';

const DefineDocumentUploadButton = ({
	className,
	refTableId,
	refTableName,
	callback,
}: DefineDocumentUploadButtonProps) => {
	const toCreatePathName = useMemo(() => {
		const queryProps = {
			_refTableName: refTableName,
			_refTableId: refTableId,
		};
		return `${ROUTERS.DEFINE_DOCUMENT_UPLOAD}?${searchParamsKey}=${encodeURIComponent(JSON.stringify(queryProps))}`;
	}, [refTableName, refTableId]);

	const { onCreateSubmit } = useCreateListSubmit({
		toCreatePathName,
	});

	const onClick = useCallback(() => {
		onCreateSubmit?.({
			callbackSuccess: callback,
		});
	}, [onCreateSubmit, callback]);

	return (
		<>
			<Button secondary name="register" onClick={onClick}>
				서류 추가
			</Button>
		</>
	);
};

export default memo(DefineDocumentUploadButton);
